// Module
var code = "<h2 id=\"understanding-your-bills-and-interest-notice\">Understanding Your Bills and Interest Notice</h2> <p>Understanding your student loans makes repayment less confusing. Know what to expect.</p> ";
// Exports
export default code;